import React from 'react'
import './styles.css'

export const ProgressGroup = ({ children }) => {
  return (
    <div className="group-chart-container" style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: 'auto',
      gridColumnGap: '0px',
      gridRowGap: '0px',
      width: '100%',
      marginTop: '2rem',
      // paddingBottom: '10rem',
      // margin: '2rem 0 10rem 0',
      // maxWidth:'100vw', 
      // overflowX: 'scroll'
    }}>
      {children}
    </div>
  )
}
